import { config } from '@web/config/env';
import { JoinUsDialogContent } from './JoinUsDialogContent';
import { useJoinUsLocalStorage } from './join-us-storage';
import { useAppSelector } from '@web/redux/store';
import { selectBuildType } from '@web/redux/selectors';
import { BuildType } from '@web/redux/Development';
import { useLocation } from 'react-router';

export default function JoinUsDialog() {
  const { date, setJoinUsDate } = useJoinUsLocalStorage();
  const buildType = useAppSelector(selectBuildType);
  const location = useLocation();
  const isInExternalAuthPage = location.pathname.includes('external-auth');
  const open = config.joinUsModalEnabled && (!date || date <= new Date()) && buildType === BuildType.default && !isInExternalAuthPage;
  // The external auth page will set the build type

  return (
    <JoinUsDialogContent
      open={open}
      onOk={() => {
        setJoinUsDate(1);
      }}
      onRemindMeLater={() => {
        setJoinUsDate(1);
      }}
    />
  );
}
